import Vue from 'vue';
import { DeviceAreaEdit, DeviceArea } from '@/interfaces/locations';
import { Commit } from 'vuex';

interface DeviceAreasState {
	deviceAreas: Record<number, DeviceArea>;
}

export default {
	namespaced: true,
	state: {
		deviceAreas: [],
	} as DeviceAreasState,

	getters: {
		getDeviceAreas: (state: DeviceAreasState): DeviceArea[] => {
			return Object.values(state.deviceAreas);
		},
	},

	mutations: {
		SET_DEVICE_AREAS(state: DeviceAreasState, deviceAreas: DeviceArea[]): void {
			const ret: Record<number, DeviceArea> = {};
			state.deviceAreas = deviceAreas.reduce((obj, deviceArea) => {
				obj[deviceArea.id] = deviceArea;
				return obj;
			}, ret);
		},

		ADD_DEVICE_AREA(state: DeviceAreasState, deviceArea: DeviceArea): void {
			Vue.set(state.deviceAreas, deviceArea.id, deviceArea);
		},

		CHANGE_DEVICE_AREA(state: DeviceAreasState, deviceArea: DeviceArea & { id: number }): void {
			const oldDeviceArea = state.deviceAreas[deviceArea.id] || {};
			Vue.set(state.deviceAreas, deviceArea.id, { ...oldDeviceArea, ...deviceArea });
		},

		DELETE_DEVICE_AREA(state: DeviceAreasState, id: number): void {
			Vue.delete(state.deviceAreas, id);
		},

		CLEAN_DEVICE_AREAS(state: DeviceAreasState): void {
			state.deviceAreas = [];
		},
	},

	actions: {
		async fetchDeviceAreas({ commit }: { commit: Commit }): Promise<void> {
			const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/device_areas`);
			if (response && response.status === 200) {
				commit('SET_DEVICE_AREAS', response.data.data);
			}
		},

		async addDeviceArea(
			{ commit }: { commit: Commit },
			{ payload }: { payload: DeviceAreaEdit }
		): Promise<void> {
			const response = await Vue.axios.post(`${process.env.VUE_APP_API_URL}/device_areas`, payload);
			if (response && response.status === 201) {
				commit('ADD_DEVICE_AREA', response.data.data);
			}
		},

		async modifyDeviceArea(
			{ commit }: { commit: Commit },
			{ id, payload }: { id: number; payload: DeviceAreaEdit }
		): Promise<void> {
			const response = await Vue.axios.put(
				`${process.env.VUE_APP_API_URL}/device_areas/${id}`,
				payload
			);
			if (response && response.status === 200) {
				commit('CHANGE_DEVICE_AREA', response.data.data);
			}
		},

		async deleteDeviceArea({ commit }: { commit: Commit }, { id }: { id: number }): Promise<void> {
			const response = await Vue.axios.delete(`${process.env.VUE_APP_API_URL}/device_areas/${id}`);
			if (response && response.status === 200) {
				commit('DELETE_DEVICE_AREA', id);
			}
		},

		cleanDeviceAreas({ commit }: { commit: Commit }): void {
			commit('CLEAN_DEVICE_AREAS');
		},
	},
};
